import { render, staticRenderFns } from "./userOverview.vue?vue&type=template&id=4381a4e8&scoped=true&"
import script from "./userOverview.vue?vue&type=script&lang=js&"
export * from "./userOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381a4e8",
  null
  
)

export default component.exports